module.exports = __webpack_public_path__ + "img/logout.5836511e.svg";